import * as React from "react";
const IconVideoOn = (props) => (
  <svg
    width={25}
    height={24}
    viewBox="0 0 25 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <rect x={2.66455} y={5} width={14} height={14} rx={4} stroke="#1C1C2C" strokeWidth={1.5} />
    <path
      d="M16.6646 9.33333L19.3358 6.95887C20.6256 5.81238 22.6646 6.72799 22.6646 8.45369V15.5463C22.6646 17.272 20.6256 18.1876 19.3358 17.0411L16.6646 14.6667V9.33333Z"
      stroke="#1C1C2C"
      strokeWidth={1.5}
    />
    <circle cx={11.6646} cy={10} r={2} stroke="#1C1C2C" strokeWidth={1.5} />
  </svg>
);
export default IconVideoOn;
